export class HoldsDetailController {
  public holdId: string;
  public holdTypeId: string;

  constructor(private $stateParams: ng.ui.IStateParamsService) {
    this.holdId = this.$stateParams.id;
    this.holdTypeId = this.$stateParams.holdTypeId;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/views/holds_detail/holds_detail_controller.ts